import BasePage from 'src/components/layouts/BasePage'
import React from 'react'
import ContactList from './ContactList'
import DocumentTitle from 'src/components/common/DocumentTitle'

export interface PeopleListProps {}

function PeopleList(_: PeopleListProps) {
  return (
    <BasePage>
      <DocumentTitle title={'Contacts'} />

      <ContactList />
    </BasePage>
  )
}

export default PeopleList
